import { render, staticRenderFns } from "./RatingTrustpilot.vue?vue&type=template&id=642a42a8&scoped=true"
import script from "./RatingTrustpilot.vue?vue&type=script&lang=js"
export * from "./RatingTrustpilot.vue?vue&type=script&lang=js"
import style0 from "./RatingTrustpilot.vue?vue&type=style&index=0&id=642a42a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a42a8",
  null
  
)

export default component.exports